import { type FC } from 'react'
import { FlowActionDropdown } from 'widgets/Flow/ui/FlowActionDropdown/FlowActionDropdown'

type IAddActionDropdownProps = {
  setOpen: (value: boolean) => void
  labelX: number
  labelY: number
  source: string
  target: string
  Content: FC
}

export const AddActionDropdown = ({
  setOpen,
  labelX,
  labelY,
  ...props
}: IAddActionDropdownProps) => {
  return (
    <FlowActionDropdown
      setOpen={setOpen}
      transform={`translateX(-50%) translate(${labelX}px, ${labelY + 12}px)`}
      width={231}
      {...props}
    />
  )
}
